import { createReportRow } from '../create-report-row/create-report-row';
import { createValuesForEntityStats } from '../create-values-for-entity-stats/create-values-for-entity-stats';
import { AdminReportCallStatsRowInput, ReportRow } from '../interfaces';

export const createMissedCallsRow = ({ entityStats, callList }: AdminReportCallStatsRowInput): ReportRow =>
  createReportRow(
    'missedCalls',
    createValuesForEntityStats(entityStats, (statsChunk) => statsChunk.getCalls(callList)?.getINumUnexpectedlyMissed()),
    { callList },
  );
